module.exports = __webpack_public_path__ + "6ed4802acc5a0b8aefb26837e218b57b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-320.webp.png
// module id = 456
// module chunks = 0